module.exports = __webpack_public_path__ + "img/logo.6e5e5c59.png";